module.exports = __webpack_public_path__ + "img/semicircle-right-green.8f2764dc.svg";